export class RequestDesaprobar {
    ID_evaluado:number;
    ID_evaluador:number;
    motivoInactivacion: string;
    ID_revisor:number;
}